// Local, self-hosted safari photography for Good Morning Tours & Safari.
// Files live in src/assets/photos/ and are bundled/optimized by the build, so
// there are no third-party round-trips. Swap these for the client's own
// licensed shots as they become available.
import lion from '@/assets/photos/lion.jpg';
import jeep from '@/assets/photos/jeep.jpg';
import acaciaSunset from '@/assets/photos/acacia-sunset.jpg';
import elesPink from '@/assets/photos/elephants-pink.jpg';
import zanzibar from '@/assets/photos/zanzibar.jpg';
import kilimanjaro from '@/assets/photos/kilimanjaro.jpg';
import giraffeSunset from '@/assets/photos/giraffe-sunset.jpg';
import elephantGreen from '@/assets/photos/elephant-green.jpg';
import elephantsGold from '@/assets/photos/elephants-gold.jpg';
import elephantGold2 from '@/assets/photos/elephant-gold-2.jpg';
import leopard from '@/assets/photos/leopard.jpg';
import giraffe from '@/assets/photos/giraffe.jpg';
import turtle from '@/assets/photos/turtle.jpg';
import town from '@/assets/photos/town.jpg';

// The images are self-hosted at a fixed size, so width/quality args are ignored.
// Kept for call-site compatibility (u(GM_IMAGES.lion, 1600) still works).
export const u = (src) => src;

export const GM_IMAGES = {
  u,
  // Hero / destination heroes
  lion, // lioness face on black — Serengeti
  jeep, // game-drive jeep, golden grass
  acaciaSunset, // lone acacia, plains sunset
  elesPink, // elephants, pink sunset — Ngorongoro
  zanzibar, // palm beach reflection — Zanzibar
  kilimanjaro, // mountain trekkers — Kilimanjaro
  giraffeSunset, // giraffe + acacia, orange dusk — Tarangire
  // Wildlife / cards
  elephantGreen, // elephant, lush green
  elephantsGold, // elephants, golden grass
  elephantGold2, // single elephant, golden grass
  leopard, // leopard on rock
  giraffe, // giraffe close-up, blue sky
  turtle, // sea turtle — marine tourism
  town, // domed old town — cultural / town tours
};

export default GM_IMAGES;
